import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { AffiliateCredentialPublic } from "@/lib/types";
import type { SupportedMarketplaceCode } from "@/lib/types";

async function fetchCredentials(): Promise<AffiliateCredentialPublic[]> {
  const { data, error } = await supabase
    .from("affiliate_credentials_public")
    .select("*")
    .order("created_at", { ascending: false });

  if (error) throw error;
  return (data ?? []) as AffiliateCredentialPublic[];
}

export function useCredentials() {
  return useQuery<AffiliateCredentialPublic[], Error>({
    queryKey: ["affiliate-credentials"],
    queryFn: fetchCredentials,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}

export function findCredentialByMarketplaceCode(
  credentials: readonly AffiliateCredentialPublic[],
  marketplaceCode: SupportedMarketplaceCode,
): AffiliateCredentialPublic | undefined {
  return credentials.find((credential) => credential.marketplace_code === marketplaceCode);
}
